var App = App || {};

App.SiteHeader = (function ($) {
    "use strict";

    function init() {
        Search();
        PrimaryNav();
        LoginShow();
    }

    function LoginShow() {
        $("#offcanvas-login-toggle").on("click", function () {
            $("#offcanvas-login").offcanvas("show");
            $("#offcanvas-why-us").offcanvas("hide");
        })
    }

    function Search() {
        const searchOffcanvas = $("#site-header-search-offcanvas");
        const searchTextField = searchOffcanvas.find("input[type='text'].form-control");

        searchOffcanvas.on("shown.bs.offcanvas", function () {
            searchTextField.focus();
        });
    }

    function PrimaryNav() {

        var hovering = false;
        var megaMenuSpeed = 300;

        var selectorMenu = $(".site-header-primary > nav");
        var selectorItem = $(".site-header-primary > nav > ul").children("li").children("a, button");

        var level2Menu = [];
        var level2MenuWhich = 0;
        var level2MenuItems = $(".site-header-primary > nav > ul").children("li").find(".mega-menu").find("a, button");

        $(".site-header-primary").find(".mega-menu").each(function () {
            $(this).find("a").attr("tabindex", -2);
        });;

        /**********************************************************************************
         ENTIRE MENU END HOVER
        /*********************************************************************************/
        selectorMenu.hover(
            function () {
                $(".site-header-logo-primary").addClass("active");
                hovering = true;
                
            },
            function () {
                hovering = false;
                selectorItem.blur();
                $(".site-header-logo-primary").removeClass("active");
                //MmOpen($(this).children("li").children("a"), megaMenuSpeed);
            }          
        );

        /**********************************************************************************
         LEVEL ONE ITEM HOVER
        /*********************************************************************************/
        selectorItem.hover(
            function () {
                if (hovering !== true) {
                    MmOpen($(this), megaMenuSpeed);
                }
                else {
                    MmOpen($(this), 1);
                }
                hovering = true;
            },
            function () { }
        );

        /**********************************************************************************
         LEVEL ONE ITEM FOCUS
        /*********************************************************************************/
        selectorItem.focus(function () {
            MmOpen($(this), 1);
            hovering = true;
        });

        /**********************************************************************************
         LEVEL ONE ITEM BLUR
        /*********************************************************************************/
        selectorItem.blur(function () {
            if (hovering === false) {
                MmClose($(this), megaMenuSpeed);
            }
        });

        /**********************************************************************************
         LEVEL ONE ITEM ARROWS
        /*********************************************************************************/
        selectorItem.keydown(function (e) {
            // right arrow
            if (e.keyCode === 39) {
                e.preventDefault();
                $(this).parent("li").next("li").children("a, button").focus();
            }
            // left arrow
            else if (e.keyCode === 37) {
                e.preventDefault();
                $(this).parent("li").prev("li").children("a, button").focus();
            }
            // down arrow
            else if (e.keyCode === 40) {
                hovering = true;
                e.preventDefault();
                level2Menu = [];
                $(this).siblings(".mega-menu").find("a:visible, button:visible").each(function () { level2Menu.push(this); });
                level2MenuWhich = 0;
                $(level2Menu[level2MenuWhich]).focus();
            }
            // esc
            else if (e.keyCode === 27) {
                var MenuuButton = $(this);
                MmClose(MenuuButton, megaMenuSpeed);
            }
        });

        /**********************************************************************************
         LEVEL 2 ITEMS ARROWS
        /*********************************************************************************/
        level2MenuItems.keydown(function (e) {
            /* right arrow */
            if (e.keyCode === 39) {
                hovering = true;
                e.preventDefault();
                $(this).parents(".mega-menu").parent("li").next("li").children("a, button").focus();
            }
            /* left arrow */
            else if (e.keyCode === 37) {
                hovering = true;
                e.preventDefault();
                $(this).parents(".mega-menu").parent("li").prev("li").children("a, button").focus();
            }
            // down arrow
            else if (e.keyCode === 40) {
                hovering = true;
                e.preventDefault();
                if (level2MenuWhich < level2Menu.length - 1) { level2MenuWhich++; }
                else { level2MenuWhich = 0; }
                $(level2Menu[level2MenuWhich]).focus();
            }
            // up arrow
            else if (e.keyCode === 38) {
                hovering = true;
                e.preventDefault();
                if (level2MenuWhich > 0) { level2MenuWhich--; }
                else { level2MenuWhich = level2Menu.length - 1; }
                $(level2Menu[level2MenuWhich]).focus();
            }
            // esc
            else if (e.keyCode === 27) {
                var MenuButton = $(this).parents(".mega-menu").siblings("a, button");
                MmClose(MenuButton, megaMenuSpeed);
            }
        });

        /**********************************************************************************
         ENTIRE EVERYTHING KEYPRESS - should we close that menu??
        /*********************************************************************************/
        selectorMenu.keydown(function (e) {
            if (e.keyCode === 9) {
                hovering = false;
                MmClose($(this).children("li").children("a, button"), 1);
            }
        });
    }

    function MmOpen(Menu, Speed) {
        Menu.attr("aria-expanded", "true").siblings(".mega-menu").stop().slideDown(Speed);
        MmClose(Menu.parents("li").siblings("li").children("a, button"), Speed);
        $("#site-header").css("z-index", "1051");
        $("#site-header").addClass("active");
        $("#site-alerts").css("z-index", "1051");
    }

    function MmClose(Menu, Speed) {
        Menu.attr("aria-expanded", "false").siblings(".mega-menu").stop().slideUp(Speed);
        $("#site-header").css("z-index", "100");
        $("#site-header").removeClass("active");
        $("#site-alerts").css("z-index", "100");
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.SiteHeader.init();
});